import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const DEFAULTS = {
  whatsapp_number: "919176501010",
  contact_email: "support@built2last.live",
  phone: "+1 478 400 7485 / +91 91765 01010",
  address: "Millenia Business Park - II, 10th Floor, Campus - 2, Dr. MGR Main Road, Kandhanchavadi, Chennai - 600096",
  working_hours: "Mon-Sat, 9:00 AM - 7:00 PM IST",
  rates: { standard: 10000, specialist: 25000, super: 50000 },
};

const SiteContext = createContext({ settings: DEFAULTS });

export const useSite = () => useContext(SiteContext);

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);

  useEffect(() => {
    api
      .get("/settings/public")
      .then((res) => {
        if (res.data && res.data.contact_email) {
          setSettings({
            ...DEFAULTS,
            ...res.data,
            rates: { ...DEFAULTS.rates, ...(res.data.rates || {}) },
          });
        }
      })
      .catch(() => {});
  }, []);

  return (
    <SiteContext.Provider value={{ settings }}>{children}</SiteContext.Provider>
  );
}
